module.exports = "<h4>PROFILE BASED OFFERS</h4>"


//////////////////
// WEBPACK FOOTER
// ./src/app/calculators/home-loan-comparison-calculator/profile-based-offers/profile-based-offers.component.html
// module id = 692
// module chunks = 8